import React from 'react'
import {
  ComposedChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  CartesianGrid,
} from 'recharts'

const SoldPrice = ({ data }) => {
  const chartData = Object.entries(data.mth).map(([month, values]) => ({
    month,
    avg: values.avg,
    count: values.count,
  }))
  const formatLargeNumbers = (value) => {
    if (value >= 1_000_000) {
      return (value / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M' // 1.6M or 2M
    } else if (value >= 100_000) {
      return Math.round(value / 1_000) + 'K' // 150K (no decimals for 100K+)
    } else if (value >= 90_000) {
      return (value / 1_000).toFixed(1).replace(/\.0$/, '') + 'K' // 90K or 95.5K
    }
    return value // No formatting for values < 90K
  }

  return (
    <ResponsiveContainer width="100%" height={400}>
      <ComposedChart
        data={chartData}
        margin={{ top: 20, right: 40, left: 20, bottom: 20 }}
      >
        {/* Define Gradient */}
        <defs>
          <linearGradient id="colorSold" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#82ca9d" stopOpacity={1} />
            <stop offset="100%" stopColor="#2c8c50" stopOpacity={1} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" angle={-45} textAnchor="end" height={60} />
        <YAxis
          yAxisId="left"
          tickFormatter={formatLargeNumbers} // Format large numbers
          label={{
            value: 'Avg Price ($)',
            angle: -90,
            position: 'insideLeft', // Keeps it inside but away from the chart
            dx: -5, // Moves label further left
            dy: 0, // Adjust vertical positioning if needed
            style: { textAnchor: 'middle' }, // Centers the text
          }}
        />
        <YAxis
          yAxisId="right"
          orientation="right"
          label={{
            value: 'Properties Sold',
            angle: -90,
            position: 'insideRight',
            dx: 15, // Moves label further right
            dy: 0,
            style: { textAnchor: 'middle' },
          }}
        />
        <Tooltip
          formatter={(value) => new Intl.NumberFormat('en-US').format(value)}
        />
        <Legend wrapperStyle={{ paddingTop: 40 }} />

        {/* Bar for properties sold */}
        <Bar
          yAxisId="right"
          dataKey="count"
          fill="url(#colorSold)"
          name="Properties Sold"
        />

        {/* Line for average price */}
        <Line
          yAxisId="left"
          type="monotone"
          dataKey="avg"
          stroke="#8884d8"
          strokeWidth={3}
          name="Avg Price ($)"
          dot={false}
        />
      </ComposedChart>
    </ResponsiveContainer>
  )
}

export default SoldPrice
